require('./currencies-container.scss')

module.exports = {
  template: require('./currencies-container.pug')()
  controller: require('./currencies-container.ctrl')
}
